const fonts = {
  avenir: require("../assets/fonts/avenir.ttf"),
  "avenir-h": require("../assets/fonts/avenir-h.ttf"),
  italic: require("../assets/fonts/italic.otf"),
};

export default fonts;
